export const getActionButtons = (notification) => [
  {
    blank: true,
    title: 'Download report again',
    url: notification.url,
    toggleSeen: true,
  },
];

export const getText = (notification) => `Report ready: ${notification.data.report_name}`;
